import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RadioGroup } from '@byte-design/ui';
import ConfirmModal, { ConfirmModalProps } from '../../../../ConfirmModal';
import { AdvAssetsAuthResult, AdvAssetsAuthStatus } from './type';
import styles from './index.module.scss';
import AssetPlayer, { AssetInfo, AssetTypeEnum } from '../../../../AssetPlayer';
import allAccessSample1 from './assets/all_access_sample1.png';
import allAccessSample2 from './assets/all_access_sample2.png';

interface AuthManageConfirmModalProps extends ConfirmModalProps {
  modalWidth?: number;
  status?: AdvAssetsAuthStatus;
  initAuthResult?: AdvAssetsAuthResult;
  onConfirm: (value: AdvAssetsAuthResult) => void;
}

const allAccessSamples: AssetInfo[] = [
  {
    type: AssetTypeEnum.IMAGE,
    info: {
      url: allAccessSample1
    }
  },
  {
    type: AssetTypeEnum.IMAGE,
    info: {
      url: allAccessSample2
    }
  }
];

const AuthManageConfirmModal = (props: AuthManageConfirmModalProps) => {
  const { t } = useTranslation();
  const {
    show,
    status = AdvAssetsAuthStatus.ADD,
    initAuthResult = AdvAssetsAuthResult.AUTHORISE,
    modalWidth = 700,
    onConfirm,
    ...rest
  } = props;

  const [authResult, setAuthResult] = useState<AdvAssetsAuthResult>(initAuthResult);
  const [showSecondConfirm, setShowSecondConfirm] = useState(false);
  const handleOkClick = () => {
    if (status === AdvAssetsAuthStatus.EDIT) {
      setShowSecondConfirm(true);
      return;
    }
    onConfirm(authResult);
  };

  const [playerAssets, setPlayerAssets] = useState<AssetInfo[]>([]);
  const closeAssetPlayer = () => {
    setPlayerAssets([]);
  };
  const showFullAccessSamples = () => {
    setPlayerAssets(allAccessSamples);
  };

  const getPrivacyContent = () => {
    switch (authResult) {
      case AdvAssetsAuthResult.AUTHORISE:
        return (
          <>
            <p className={styles.tips}>{t('share_full_tips')}</p>
            <h3 className={styles.questionTitle}>
              {t('share_full_question1')}
              <span className={styles.viewSamplesBtn} onClick={showFullAccessSamples}>
                {t('view_samples_btn')}
              </span>
            </h3>
            <p className={styles.questionAnswer}>{t('share_full_answer1')}</p>
            <h3 className={styles.questionTitle}>{t('share_full_question2')}</h3>
            <p className={styles.questionAnswer}>{t('share_full_answer2')}</p>
            <h3 className={styles.questionTitle}>{t('share_full_question3')}</h3>
            <p className={styles.questionAnswer}>{t('share_full_answer3')}</p>
          </>
        );
      case AdvAssetsAuthResult.REJECT:
        return (
          <>
            <p className={styles.normalParagraph}>{t('share_no_data_text1')}</p>
            <p className={styles.normalParagraph}>{t('share_no_data_text2')}</p>
          </>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <ConfirmModal
        show={show}
        width={modalWidth}
        headerTitle="auth_modal_header_title"
        className={styles.authManageModal}
        {...rest}
        onOk={handleOkClick}
      >
        <div className={styles.content}>
          <div className={styles.authoriseRadio}>
            <RadioGroup value={authResult} onChange={(value) => setAuthResult(value!)}>
              <RadioGroup.Radio value={AdvAssetsAuthResult.AUTHORISE}>
                {t('adv_auth_authorise')}
              </RadioGroup.Radio>
              <RadioGroup.Radio value={AdvAssetsAuthResult.REJECT}>{t('adv_auth_reject')}</RadioGroup.Radio>
            </RadioGroup>
          </div>

          <div className={styles.notificationSection}>{getPrivacyContent()}</div>
        </div>
      </ConfirmModal>

      {status === AdvAssetsAuthStatus.EDIT && showSecondConfirm === true && (
        <ConfirmModal
          show
          width={400}
          headerTitle="auth_second_confirm_modal_header_title"
          className={styles.authSecondConfirmModal}
          okText={t('modal_bottom_change')}
          onCancel={() => setShowSecondConfirm(false)}
          onOk={() => onConfirm(authResult)}
        >
          <div className={styles.secondConfirmContent}>{t('auth_second_confirm_modal_content')}</div>
        </ConfirmModal>
      )}

      <AssetPlayer assets={playerAssets} show={playerAssets.length > 0} onClose={closeAssetPlayer} />
    </>
  );
};
export default AuthManageConfirmModal;
